export default "__VITE_ASSET__02d734a6__"